import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/cbb399f4-e23f-4a15-b234-e03bc035bab7";
export const REGISTER_URL = "https://a.ntrk2.com/457204f1-bdd5-47e7-af5d-97c0975cca36";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://mbk678.kzw2a.com/download?id=c10dc919s3s2655";

export * from "./codes";
export * from "./context";
